type CommissionStatus = "pending" | "earned" | "approved" | "paid";
type WebhookStatus = "received" | "processing" | "processed" | "failed" | "skipped" | "ignored";

interface StatusBadgeProps {
  status: CommissionStatus | WebhookStatus | string;
  suffix?: string;
}

const variantMap: Record<string, "earned" | "approved" | "paid" | "pending" | "default"> = {
  pending: "pending",
  earned: "earned",
  approved: "approved",
  paid: "paid",
  received: "pending",
  processing: "pending",
  processed: "earned",
  failed: "pending",
  ignored: "default",
  skipped: "default",
};

export function StatusBadge({ status, suffix }: StatusBadgeProps) {
  const variant = variantMap[status] ?? "default";
  const cls = ["badge", variant !== "default" && variant].filter(Boolean).join(" ");
  return (
    <span className={cls}>
      {status}
      {suffix ? ` ${suffix}` : ""}
    </span>
  );
}
